import { gql } from '@apollo/client';

const GQL_DESCRIBABLE_UPDATE = gql`
  mutation DescribableUpdate($input: DescribableContentUpdateInput!) {
    describableContentUpdate(input: $input) {
      describable {
        ... on Photo {
          id
          description {
            id
            content
          }
        }
        ... on Video {
          id
          description {
            id
            content
          }
        }
      }
      errors {
        message
        path
        error
      }
    }
  }
`;

export default GQL_DESCRIBABLE_UPDATE;
